
import * as React from "react";
import { Api } from "../../../lib/Api";
import { IRestaurant, IRestaurantSaveData, IPaymentOption } from "../../../interfaces/IRestaurant";
import ImageUploader from "../../global/ImageUploader";
import { Checkbox } from "../../../../avernus/checkbox/source/Checkbox";
import AddressBox, { ICountryOption } from "../../global/AddressBox";
import OpeningHours from "../../global/OpeningHours";
import { IDelivery } from "../../../interfaces/IDelivery";
import DeliveryBox from "./DeliveryBox";
import Config from "../../../Config";
import HighlightLabel from "../../global/HighlightLabel";
import ImageUpload from "../../global/ImageUpload";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";


export interface IXhrUrls{
    get        : string
    list       ?: string
    remove     ?: string
    addOrModify: string
    init       : string
}

interface IEditRestaurantProps {
    id                : number
    urlPrefix         : string
    changed           : IChangedFunction
    defaultUploadImage: string
    idName            : string
    xhrUrls           : IXhrUrls
    removeBtnDisabled?: boolean
}

interface IChangedFunction{
    (wantToClose:boolean, restaurantId:number):void
}


interface IEditRestaurantState extends IInitResult {
    success             : string
    error               : string
    form                : IForm
    loading             : boolean
    formId              : number
    uploaded_image      : string
    uploaded_photo      : Array<string>

    changedForm         : boolean
}

interface IForm extends IRestaurant{
    removeImageIfExists?:boolean
    opening_hours ?: any
}

interface ISaveForm{
    id      ?: number
    success : string
    error   : string
}

interface IOption{
    label: string
    value: number
}
interface IInitResult{
    restaurantTypeOptions: Array<IOption>
    typeOptions          : Array<IOption>
    countryOptions       : Array<ICountryOption>
    deliveryOptions      : Array<IDelivery>
    paymentOptions       : Array<IPaymentOption>
}

interface IgetResult{
    item:IRestaurantSaveData
    error:string
}

export default class EditRestaurant extends React.Component<IEditRestaurantProps, IEditRestaurantState>{

  	constructor(props:IEditRestaurantProps){
        super(props);
        this.state = {
            success                 : null,
            error                   : null,
            form                    : this.props.id === 0?this.createEmptyForm(): null,
            loading                 : this.props.id>0,
            formId                  : this.props.id,
            uploaded_image          : this.getSampleImageValue(),
            uploaded_photo          : [this.getSampleImageValue()],
            restaurantTypeOptions   : null,
            typeOptions             : null,
            countryOptions          : null,
            deliveryOptions         : null,
            paymentOptions          : null,
            changedForm             : false
        };
        this.init();
    }

    private getSampleImageValue(): string {
        return this.props.defaultUploadImage;
    }

    createEmptyForm(): IForm {
        return {
            id                                       : 0,
            img                                      : '',
            restaurantTypeId                         : 0,
            name                                     : '',
            description                              : '',

            addressCountry                           : '',
            addressState                             : '',
            addressCity                              : '',
            addressStreet                            : '',
            addressZip                               : '',
            longitude                                : '',
            latitude                                 : '',

            openingHoursMondayStart                  : '',
            openingHoursMondayEnd                    : '',
            openingHoursTuesdayStart                 : '',
            openingHoursTuesdayEnd                   : '',
            openingHoursWednesdayStart               : '',
            openingHoursWednesdayEnd                 : '',
            openingHoursThursdayStart                : '',
            openingHoursThursdayEnd                  : '',
            openingHoursFridayStart                  : '',
            openingHoursFridayEnd                    : '',
            openingHoursSaturdayStart                : '',
            openingHoursSaturdayEnd                  : '',
            openingHoursSundayStart                  : '',
            openingHoursSundayEnd                    : '',

            openingHoursWeeklyExceptionWeekNumber    : 0,
            openingHoursWeeklyExceptionMondayStart   : '',
            openingHoursWeeklyExceptionMondayEnd     : '',
            openingHoursWeeklyExceptionTuesdayStart  : '',
            openingHoursWeeklyExceptionTuesdayEnd    : '',
            openingHoursWeeklyExceptionWednesdayStart: '',
            openingHoursWeeklyExceptionWednesdayEnd  : '',
            openingHoursWeeklyExceptionThursdayStart : '',
            openingHoursWeeklyExceptionThursdayEnd   : '',
            openingHoursWeeklyExceptionFridayStart   : '',
            openingHoursWeeklyExceptionFridayEnd     : '',
            openingHoursWeeklyExceptionSaturdayStart : '',
            openingHoursWeeklyExceptionSaturdayEnd   : '',
            openingHoursWeeklyExceptionSundayStart   : '',
            openingHoursWeeklyExceptionSundayEnd     : '',

            checkedTypes                             : [],
            photos                                   : [],
            deliveries                               : [],
            timeZone                                 : '',
            payments                                 : [],

            profile_photo                            : '',
            cover_photo                              : '',
            id_card                                  : '',

            opening_hours: []
        };
    }

    private init(){
        Api.call(this.props.xhrUrls.init, {}, (initResult:IInitResult)=>{
            this.setState({
                restaurantTypeOptions: initResult.restaurantTypeOptions,
                typeOptions          : initResult.typeOptions,
                countryOptions       : initResult.countryOptions,
                deliveryOptions      : initResult.deliveryOptions,
                paymentOptions       : initResult.paymentOptions
            }, () =>{
                if ( this.props.id>0 ) {
                    Api.call(this.props.xhrUrls.get, { id: this.props.id}, (result:IgetResult) =>{
                        if ( result.item === null ) {
                            this.setState({
                                error                  : result.error,
                                loading                : false,
                            });
                        }else{
                            let form:IForm                          = result.item as any;
                            console.log(form);
                            let uploaded_image          = this.state.uploaded_image;
                            let uploaded_photo          = this.state.uploaded_photo;
                            if ( form.img !== '' ) {
                                uploaded_image = form.img;
                            }

                            for (var key in form.photos) {
                                var photo = form.photos[key];
                                if ( photo !== '' ) {
                                    uploaded_photo[key] = photo;
                                }
                            }

                            this.setState({
                                form                   : form,
                                loading                : false,
                                error                  : null,
                                uploaded_image         : uploaded_image,
                                uploaded_photo         : uploaded_photo
                            });
                        }

                    } );
                }
            });
        });
    }

    private getTimeZone(cb):void{

        this.setState({
            loading: true
        }, ()=>{
            Api.call('/getTimeZone', {
                latitude    : this.state.form.latitude,
                longitude   : this.state.form.longitude,
                apiKey      : Config.getAPIKey()
            }, (result)=>{
                let form = this.state.form;
                form.timeZone = result.timeZone;
                this.setState({
                    form: form
                }, ()=>{
                    cb();
                });
            });


        });

    }

    private submitHandler(evt): void {
        if ( evt !== null ) {
            evt.preventDefault();
        }
        this.getTimeZone(()=>{
            let saveUrl:string                          = this.props.xhrUrls.addOrModify;
            let saveData:IRestaurantSaveData            = this.state.form as any;

            Api.call(saveUrl, saveData, (result:ISaveForm)=>{
                if ( result.success !== undefined ) {
                    this.setState({
                        loading:    false,
                        success:    result.success,
                        error:      result.error,
                        formId:     result.id!==undefined?result.id:0
                    }, () =>{
                        // FIXME: figyelni mert a profilnal is ez van
                        this.props.changed(false, (result.id!==undefined?result.id:0));
                    });
                }
            });
        });

    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        var form = this.state.form;
        form[type] = evt.target.value;
        this.setState({
            form: form
        });
    }

    private removeBtnClickHandler(evt): void {
        evt.preventDefault();
        if (window.confirm("Are you sure want to delete this  \""+this.state.form.name+"\" restaurant?")) {
            Api.call(this.props.xhrUrls.remove, { id: this.props.id }, (result:ISaveForm)=>{
                this.setState({
                    success: result.success,
                    error: result.error
                }, () =>{
                    setTimeout(() => {
                        this.props.changed(true, this.props.id);
                    }, 1000);
                });
            });
        }
    }

    private cancelBtnClickHandler(evt): void {
        evt.preventDefault();
        this.props.changed(true, this.props.id);
    }

    private getypeCheckboxChangeHandler(evt, id:number, saveAfterChange:boolean=false): void {
        if ( evt !== null ) {
            evt.preventDefault();
        }
        let form        = this.state.form;
        if ( form.checkedTypes.indexOf(id) > -1 ) {
            form.checkedTypes.splice(form.checkedTypes.indexOf(id) , 1);
        }else{
            form.checkedTypes.push(id);
        }
        this.setState({
            form: form
        }, ()=>{
            if ( saveAfterChange === true ) {
                this.submitHandler(evt);
            }
        });
    }

    //

    private paymentsChangeHandler(evt, value: string) {
        if ( evt !== null ) {
            evt.preventDefault();
        }
        let form        = this.state.form;
        if ( form.payments.indexOf(value) > -1 ) {
            form.payments.splice(form.payments.indexOf(value) , 1);
        }else{
            form.payments.push(value);
        }
        this.setState({
            form: form
        });
    }

    private savePhoto(type, file) {
          let form = this.state.form;
          form[type] = file;
          this.setState({
              form: form
          });

    }

    render() {
        let removeBtnDisabled = (this.props.removeBtnDisabled !== undefined && this.props.removeBtnDisabled === true);
        return (
            <>
                { (this.state.loading === true || this.state.form === null)?<div>
                    { this.state.error !== null?<div className="alert alert-danger">
                                { this.state.error }
                    </div>:<div className="loading_row"><LoaderComp show={true} /></div>}
                </div>:<>
                    <HighlightLabel label={'Introduction'} icon={"img/introduction-icon.png"} />
                    <form onSubmit={ e => this.submitHandler(e) }>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-row">
                                    <div className="col">
                                        <textarea className="s-form-control" name="description" rows={6} value={this.state.form.description} onChange={ e => this.changeInputHandler(e,'description') } placeholder="Restaurant description"></textarea>
                                    </div>
                                </div>

                                <div className = "row">
                                    <div className = "col-6">
                                        <ImageUpload
                                            id = {'profile_picture'}
                                            label={'Profile picture'}
                                            icon={'/img/upload_photo_icon.png'}
                                            change={(file) => this.savePhoto('upload_profile_photo', file)}
                                            value={this.state.form.photos['profilePhoto']}
                                        />
                                    </div>
                                    <div className = "col-6">
                                        <ImageUpload
                                            id = {'cover_photo'}
                                            label={'Cover photo'}
                                            icon={'/img/upload_photo_icon.png'}
                                            change={(file) => this.savePhoto('upload_cover_photo', file)}
                                            value={this.state.form.photos['coverPhoto']}
                                        />
                                    </div>
                                    <div className = "col">
                                        <ImageUpload
                                            id = {'id_card'}
                                            label={'please upload your ID card or driving licence'}
                                            icon={'/img/upload_photo_icon.png'}
                                            change={(file) => this.savePhoto('upload_id_card', file)}
                                            value={this.state.form.photos['idCard']}
                                        />
                                    </div>
                                </div>


                                <div id="er_address">
                                    { this.state.countryOptions !== null?<AddressBox
                                        key={'address_box_' + this.state.formId}

                                        countryOptions={this.state.countryOptions}
                                        addressCountry={this.state.form.addressCountry}
                                        addressState={this.state.form.addressState}
                                        addressCity={this.state.form.addressCity}
                                        addressStreet={this.state.form.addressStreet}
                                        addressZip={this.state.form.addressZip}
                                        longitude={this.state.form.longitude}
                                        latitude={this.state.form.latitude}

                                        changed={ (ret) => {
                                            let form            = this.state.form;
                                            form.addressCountry = ret.addressCountry;
                                            form.addressState   = ret.addressState;
                                            form.addressCity    = ret.addressCity;
                                            form.addressStreet  = ret.addressStreet;
                                            form.addressZip     = ret.addressZip;
                                            form.longitude      = ret.longitude;
                                            form.latitude       = ret.latitude;
                                            this.setState({
                                                form: form
                                            });
                                        } }
                                    />:'Loading ...' }
                                </div>

                                <div id="er_opening_hours">
                                    <OpeningHours
                                        key={'opening_hours_'+this.props.id}
                                        hideTitleRow={false}
                                        openingHours = {this.state.form.opening_hours}

                                        changed={ (ret) => {
                                            let form  = this.state.form;
                                            form.opening_hours = ret;

                                            this.setState({
                                                form        : form,
                                                changedForm : true
                                            });
                                        } }
                                    />

                                </div>


                                <br />
                                <br />

                                {this.buttonBar()}
                            </div>
                        </div>


                        <input type="hidden" id="form_id" value={this.state.formId} />
                    </form>
                    <div className = "back-btn">
                        <button type="button" className="back_btn" onClick={ e => this.cancelBtnClickHandler(e) }>Back</button>
                    </div>
                </> }
            </>
        );
    }

    private buttonBar(){
        let removeBtnDisabled = (this.props.removeBtnDisabled !== undefined && this.props.removeBtnDisabled===true)?true:false;
        return  <div className="form-row" style={{
                        marginTop: '15px'
                    }}>
                    <div className="col-sm-12">
                        { this.state.error !== null?<div className="alert alert-danger">
                                { this.state.error }
                        </div>:''}
                        { this.state.success !== null?<div className="alert alert-success">
                                { this.state.success }
                        </div>:''
                        }
                    </div>
                    <div className="col-2"></div>
                    <div className="col-8">
                        <button className="green_btn" id={this.props.idName+"_save_btn"} type="submit">SAVE</button>
                    </div>
                    <div className="col-2"></div>
                    <div className="col-2"></div>
                    { removeBtnDisabled === false ?<div className="col-8">
                        { this.props.id >0 ?<button className="red_btn btn-block" id={this.props.idName+"_remove_btn"} type="button" onClick={ e => this.removeBtnClickHandler(e) }
                        >Remove</button>:'' }
                    </div>:'' }
                    <div className="col-2"></div>


                </div>
    }
}
